import React from 'react';
import Toast, { ToastConfig } from 'react-native-toast-message';

import { ToastDefault } from '../molecules/toast';
import type { ToastDefaultProps } from '../molecules/toast';

interface ToastPopupProps {
  props: ToastDefaultProps;
}

const toastConfig = {
  success: ({ props }: ToastPopupProps) => <ToastDefault {...props} />,
  warning: ({ props }: ToastPopupProps) => <ToastDefault {...props} />,
  error: ({ props }: ToastPopupProps) => <ToastDefault {...props} />,
};

interface ToastProviderProps {
  config?: ToastConfig;
  children: React.ReactNode;
}
export const ToastProvider = ({
  config,
  children,
  ...rest
}: ToastProviderProps) => (
  <>
    {children}
    <Toast config={{ ...toastConfig, ...config }} {...rest} />
  </>
);
export const toast = Toast;
